import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";

const blockTypes = [
  { type: "heading", label: "Heading", icon: "ph:text-h-bold" },
  { type: "paragraph", label: "Paragraph", icon: "ph:paragraph-bold" },
  { type: "image", label: "Image", icon: "ph:image-bold" },
  { type: "quote", label: "Quote", icon: "ph:quotes-bold" },
  { type: "button", label: "Button", icon: "ph:cursor-click-bold" },
  { type: "columns", label: "2 Columns", icon: "ph:columns-bold" },
  { type: "divider", label: "Divider", icon: "ph:minus-bold" },
  { type: "video", label: "Video", icon: "ph:play-circle-bold" },
  { type: "embed", label: "Embed", icon: "ph:code-bold" },
  { type: "html", label: "HTML", icon: "ph:brackets-curly-bold" },
  { type: "table", label: "Table", icon: "ph:table-bold" },
];

export const BLOCK_TYPE_OPTIONS = blockTypes.map(({ type, label }) => ({ type, label }));

export const BUTTON_TARGET_OPTIONS = [
  { value: "_self", label: "Same tab" },
  { value: "_blank", label: "New tab" },
];

const BlockToolbar = ({ onAddBlock }) => (
  <div className="gutenberg-toolbar">
    <div className="gutenberg-toolbar__items">
      {blockTypes.map((blockType) => (
        <button type="button" key={blockType.type} onClick={() => onAddBlock(blockType.type)}>
          <span><Icon icon={blockType.icon} height={16} /></span>
          {blockType.label}
        </button>
      ))}
    </div>
  </div>
);

export default BlockToolbar;
